import { useEffect } from "react";
import Lenis from "lenis";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { HowItWorks } from "@/components/HowItWorks";
import { FeatureBlock } from "@/components/FeatureBlock";
import { Benefits } from "@/components/Benefits";
import { LifestyleStrip } from "@/components/LifestyleStrip";
import { RoiGrid } from "@/components/RoiGrid";
import { About } from "@/components/About";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -20, duration: 1.6 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <main data-testid="landing-page">
      <Nav />
      <Hero />
      <HowItWorks />
      <FeatureBlock
        poster="/media/feature-vitals.png"
        eyebrow="01 — The Checkup"
        title="A full checkup in 60 seconds."
        copy="Heart, blood pressure and oxygen — all checked in one quick visit."
        testid="feature-vitals"
      />
      <FeatureBlock
        poster="/media/feature-report.png"
        eyebrow="02 — Your Results"
        title="Printed. Sent. Done."
        copy="Your doctor gets the results right away. You walk out with a copy in your hand."
        testid="feature-report"
      />
      <Benefits />
      <LifestyleStrip />
      <RoiGrid />
      <About />
      <Faq />
      <Footer />
    </main>
  );
}
